export default __webpack_public_path__ + "static/media/Warglory Armbands.69fd6b90.jpg";